import styled from 'styled-components';
import { astriskStyle } from 'src/styles/CommonStyles.styled';
export const DropdownLabel = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 12px;
    padding-bottom: 10px;
    ${astriskStyle};
`;
